import theme from '../../../../../lib/theme';
import { HubBlockProps } from './HubBlock';

const {
  layers,
  layouts,
  scale,
  corners,
  media,
  colors,
  font: {
    families,
    spacings,
    heights,

    ...font
  },
} = theme;

export default ({ block: { headerImageURL } }: HubBlockProps) => ({
  wrapper: {
    marginTop: `-${scale.s} !important`,
  },

  topPanel: {
    ...layouts.panel,

    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: colors.light_grey,
    backgroundImage: `linear-gradient(317.84deg, rgba(158,66,255,0.3) 0%, rgba(101,31,255,0.75) 100%), url('${headerImageURL}')`,
    minHeight: '40vh',
    position: 'relative',
  },

  topContainer: {
    ...layouts.container('m'),
    ...layouts.column,

    justifyContent: 'center',
    flex: '1 0',
  },

  scrim: {
    textShadow: `0px 0px ${scale.xxxs} rgba(0, 0, 0, 0.5)`,
  },

  middlePanel: {
    ...layouts.panel,

    backgroundColor: colors.light_grey,
  },

  middleContainer: {
    ...layouts.container('l'),
    ...layouts.spacedColumn('m'),

    paddingTop: scale.m,

    [media.s.up]: {
      ...layouts.spacedRow('l'),

      alignItems: 'flex-start',
    },
  },

  introduction: {
    ...layouts.spacedColumn('s'),
  },

  bottomPanel: {
    ...layouts.panel,

    backgroundColor: colors.light_grey,
  },

  bottomContainer: {
    ...layouts.container('m'),
    ...layouts.spacedColumn('m'),
  },

  navigationCards: {
    ...layouts.row,

    flexWrap: 'wrap',
    justifyContent: 'center',
  },

  navigationCard: {
    ...layouts.column,

    alignItems: 'center',
    justifyContent: 'center',
    width: 131,
    height: 131,
    overflow: 'hidden',
    margin: scale.xxs,
    backgroundColor: colors.white,
    borderRadius: corners.m,
    border: `1px solid ${colors.grey}`,
    padding: scale.xs,
    textDecoration: 'none',
    textAlign: 'center',
    color: colors.black,
    transition: 'background-color 150ms linear',

    [media.s.up]: {
      width: 139,
      height: 139,
    },

    '&:hover': {
      backgroundColor: colors.light_grey,
    },
  },

  loading: {
    paddingBottom: scale.m,
    backgroundImage:
      "url('https://images.startsat60.com/frontend/loading-spinner-sas.gif')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: 50,
    height: 10,
  },

  navigationCardTitle: {
    marginTop: scale.xxxs,
    fontSize: font.s,
    lineHeight: heights.s,
    fontFamily: families.primary,
    letterSpacing: spacings.m,
  },

  subscribe: {
    zIndex: layers.high,
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translate(-50%, 50%)',
    height: 60,
    padding: `0 ${scale.m}`,
    fontSize: font.xl,
    lineHeight: heights.xl,
  },

  feedbackForm: {
    ...layouts.spacedColumn('s'),
  },

  feedbackGate: {
    ...layouts.spacedColumn('s'),
  },

  feedbackCallout: {
    width: '100%',
    maxWidth: 360,
  },
});
